import Swiper from 'swiper/bundle';

export default () => {
  const filters = document.querySelectorAll('.filter_list');

  // console.log(filters);

  function createFilters(item) {
    const controls = item.dataset.swiperControls;

    // const activeSlide = item.querySelectorAll(".swiper-slide");
    // let slideStart = 0;

    // activeSlide.forEach((slide, index) => {
    //   if (slide.classList.contains("is-active")) {
    //     slideStart = index;
    //     console.log(slideStart);
    //     return index;
    //   }
    //   slideStart = 0;
    // });

    const swiper = new Swiper(item, {
      slidesPerView: 3,
      slidesPerGroup: 1,
      threshold: 40,
      center: true,
      freeMode: false,
      // slideToClickedSlide: true,
      // initialSlide: slideStart,
      spaceBetween: 10,
      watchOverflow: true,
      navigation: {
        nextEl: `.swiper-button-next--${controls}`,
        prevEl: `.swiper-button-prev--${controls}`,
      },
      breakpoints: {
        700: {
          slidesPerView: 4,
          slidesPerGroup: 1,
        },
        1180: {
          slidesPerView: 5,
          slidesPerGroup: 1,
        },
      },
    });

    swiper.slideTo(getSlideIndexByClass('is-active'));
  }

  function getSlideIndexByClass(className) {
    let index = 0;
    const wrappers = document.querySelectorAll('.swiper-wrapper');
    wrappers.forEach((wrapper, wrInd) => {
      const slides = wrapper.querySelectorAll('.swiper-slide');

      slides.forEach((active, ind) => {
        if (active.classList.contains(className)) {
          index = ind;
          return false;
        }
      });

      // console.log(index);
    });
    return index;
  }

  function init() {
    filters.forEach((filter) => {
      createFilters(filter);
    });
  }

  return Object.freeze({
    init,
  });
};
